/**
 * Request to duplicate the EntityDocumentsAndOcr component,
 * the duplicated component is integrated into new API endpoints
 */

export { EntityDocumentsAndOcr as EntityDocumentsAndOcrV2 } from './EntityDocumentsAndOcr';
